import {
  defineNuxtRouteMiddleware,
  setPageLayout,
  useSeoMeta,
  navigateTo,
  useHeadSafe,
  useHead
} from "#imports";
import { useCMSContent } from "#nk/composables/cms";
import { rand } from "@vueuse/core";
export default defineNuxtRouteMiddleware(async (to, _from) => {
  const page = await useCMSContent(to);
  if (page == null || page != null && page.value.hasError) {
    return;
  }
  if (page.value.isRedirect && page.value.redirectTo != null) {
    return navigateTo(
      {
        path: page.value.redirectTo,
        hash: to.hash,
        query: {
          ...to.query,
          // cache buster, because cache prevents the redirect if the page is navigated from breadcrumb
          cb: Math.floor(Date.now() / 1e3) + rand(0, 1e3)
        }
      },
      { replace: true }
    );
  }
  if (page && page.value && typeof page.value.theme === "string") {
    setPageLayout(page.value.theme);
  }
  useSeoMeta({
    title: page.value.title,
    description: page.value.description
  });
  if (page.value.theme !== "default") {
    useHeadSafe({
      bodyAttrs: {
        class: `nk-theme-${page.value.theme}`
      }
    });
  }
  if (page.value.context && Array.isArray(page.value.context)) {
    const template = page.value.context.find(
      (obj) => obj.template === "TemplateVeranstaltungenDetail"
    );
    const event = page.value.apiCallsContent.veranstaltung;
    if (template != null && event != null) {
      const googleHeader = {
        "@context": "https://schema.org",
        "@type": "Event",
        name: event.titel,
        startDate: event.datum_von,
        endDate: event.datum_bis,
        eventStatus: "https://schema.org/EventScheduled",
        image: [event.bild],
        description: event.plain_text
      };
      if (event.veranstalter) {
        googleHeader.organizer = {
          "@type": "Organization",
          name: event.veranstalter
        };
      } else if (event.brancheneintrag_veranstalter) {
        googleHeader.organizer = {
          "@type": "Organization",
          name: event.brancheneintrag_veranstalter.titel,
          url: event.brancheneintrag_veranstalter.kontakt.link,
          image: event.brancheneintrag_veranstalter.bild,
          email: event.brancheneintrag_veranstalter.kontakt.email,
          telephone: event.brancheneintrag_veranstalter.kontakt.telefon,
          address: {
            "@type": "PostalAddress",
            streetAddress: event.brancheneintrag_veranstalter.adresse.strasse,
            addressLocality: event.brancheneintrag_veranstalter.adresse.ort,
            postalCode: event.brancheneintrag_veranstalter.adresse.plz,
            addressCountry: "DE"
          }
        };
      }
      if (event.veranstaltungsort) {
        googleHeader.location = {
          "@type": "Place",
          name: event.veranstaltungsort,
          address: {
            "@type": "PostalAddress",
            streetAddress: event.adresse.strasse,
            addressLocality: event.adresse.ort,
            postalCode: event.adresse.plz,
            addressCountry: "DE"
          }
        };
      } else if (event.brancheneintrag_veranstaltungsort) {
        googleHeader.location = {
          "@type": "Place",
          name: event.brancheneintrag_veranstaltungsort.titel,
          url: event.brancheneintrag_veranstaltungsort.kontakt.link,
          image: event.brancheneintrag_veranstaltungsort.bild,
          telephone: event.brancheneintrag_veranstaltungsort.kontakt.telefon,
          address: {
            "@type": "PostalAddress",
            streetAddress: event.brancheneintrag_veranstaltungsort.adresse.strasse,
            addressLocality: event.brancheneintrag_veranstaltungsort.adresse.ort,
            postalCode: event.brancheneintrag_veranstaltungsort.adresse.plz,
            addressCountry: "DE"
          }
        };
      } else {
        googleHeader.location = {
          "@type": "Place",
          address: {
            "@type": "PostalAddress",
            addressCountry: "DE"
          }
        };
      }
      const jsonGoogleHeader = JSON.stringify(googleHeader);
      useHead({
        script: [
          {
            hid: "structureddata",
            type: "application/ld+json",
            innerHTML: jsonGoogleHeader
          }
        ]
      });
    }
  }
});
